<template>
    <v-layout v-if="dialog.isOpen" row justify-center>
        <v-dialog v-model="dialog.isOpen" max-width="30vw">
            <v-card>
                <v-card-title class="headline">
                    <v-icon>notification_important</v-icon>
                    <span class="title">Notification</span>
                </v-card-title>

                <div class="text-notification">
                    {{ dialog.message }}
                </div>

                <v-card-actions>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import { mapState } from 'vuex'
    export default {
        data () {
            return {}
        },
        computed:{
            ...mapState('app',[
                'dialog'
            ]),
        },
        methods:{
            close(){
                this.dialog.isOpen = false;
            }
        }
    }
</script>

<style scoped>
    .headline{
        justify-content: center;
    }
    .title{
        font-size: 1em;
    }
    .text-notification{
        font-family: 'Montserrat', Helvetica, Arial, sans-serif;
        padding: 16px;
        text-align: center;
        margin-bottom: 1.5rem;
    }
</style>
